import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=7074f0ba&scoped=true"
import script from "./PageMenu.vue?vue&type=script&lang=js"
export * from "./PageMenu.vue?vue&type=script&lang=js"
import style0 from "./PageMenu.vue?vue&type=style&index=0&id=7074f0ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074f0ba",
  null
  
)

export default component.exports